import { sdkRequest, translateServerErrors } from '@eventbrite/http';
import { formatUrl } from 'url-lib';
import { EVENT_IMAGE_PLACEHOLDER_URL } from '../constants';
import { EventInfo } from '../types';
import { GENERAL_ERROR_SPEC } from './constants';

export const getEvent = (eventId: string) =>
    sdkRequest(
        formatUrl(`/api/v3/events/${eventId}/?expand=sales_data_with_null`),
    ).catch(translateServerErrors(GENERAL_ERROR_SPEC));

export const getEventInfo = async (eventId: string): Promise<EventInfo> => {
    const {
        currency = '',
        end: { local: endDate = '' } = {},
        id = '',
        locale = '',
        logo,
        name: { text: name = '' } = {},
        sales_data_with_null: { net = 0 } = {},
    } = await getEvent(eventId);

    const payoutAmount = +net;

    return {
        currency,
        endDate,
        id,
        locale,
        logo: logo?.url || EVENT_IMAGE_PLACEHOLDER_URL,
        name,
        payoutAmount,
    };
};
